// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cvr: CountryValidator<"DK"> = createValidator(
  "dk.cvr",
  57,
);

export default cvr;
export const compact = cvr.compact;
export const format = cvr.format;
export const validate = cvr.validate;
export const generate = (): string =>
  cvr.generate?.() ??
  (() => {
    throw new Error(
      "Validator dk.cvr cannot generate values",
    );
  })();
